import * as THREE from 'three'
import GSAP from 'gsap'
import Experience from '../Experience'
import Cloud from './Cloud'
import East from './East'
import Environment from './Environment'
import Field from './Field'
import North from './North'
import Outside from './Outside'
import South from './South'
import West from './West'

export default class World {
  constructor() {
    //setup
    this.experience = new Experience()
    this.camera = this.experience.camera
    this.scene = this.experience.scene
    this.resources = this.experience.resources

    //resources
    this.resources.on('ready', () => {
      this.north = new North()
      this.south = new South()
      this.west = new West()
      this.east = new East()
      this.field = new Field()
      this.outside = new Outside()
      this.cloud = new Cloud()
      this.environment = new Environment()
      this.closeLoader()
    })
  }
  closeLoader() {
    this.loader = document.querySelector('.loader')
    GSAP.to(this.cloud.model.position, { x: 2, duration: 10, delay: 0.8, ease: 'Power1.easeOut' })
    GSAP.to(this.loader, { yPercent: 100, autoAlpha: 0, duration: 1.5 }, '<')
    GSAP.to(this.camera.instance.position, { y: 2, z: 14, duration: 4, delay: 0.4, ease: 'Power1.easeOut', onComplete: this.destroy() }, '<')
  }

  destroy() {
    setTimeout(() => {
      this.scene.remove(this.cloud.model)
    }, 20000)

    this.scene.traverse(child => {
      if (child instanceof THREE.Mesh && child.name === 'cloud') {
        child.geometry.dispose()
      }
    })
  }
}
